import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'
import { useTranslation } from 'shared/hooks/useSafeTranslation'

import useStyle from 'shared/hooks/useStyle'
import TempContainerIcon from 'shared/TempContainerIcon'
import styles from './AssertDashboardCardItem.style'

const propTypes = {
    number: PropTypes.string.isRequired,
    isInProcess: PropTypes.bool.isRequired,
    currentOrderNumber: PropTypes.string,
    tempRange: PropTypes.string,
    productType: PropTypes.string,
    answeredBy: PropTypes.string,
    onClick: PropTypes.func.isRequired,
}

const AssertDashboardCardItem = ({
    number,
    isInProcess,
    tempRange,
    productType,
    currentOrderNumber,
    answeredBy,
    onClick,
}) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()

    const handleClickListItem = useCallback(() => {
        onClick({ number })
    }, [
        number,
        onClick,
    ])

    const modelName = productType ? ` | ${productType}` : ''

    return (
        <div
            css={classes.container}
        >
            <div
                data-testid="assert-dashboard-card"
                aria-hidden="true"
                onClick={handleClickListItem}
            >
                <div css={classes.numberLine}>
                    <div css={classes.numberTypeContainer}>
                        <Typography
                            variant="h3"
                            css={classes.numberLineLetters}
                        >
                            {`${number}${modelName}`}
                        </Typography>
                    </div>
                    <TempContainerIcon tempRange={tempRange} />
                </div>
                <div css={classes.bottomWrapper}>
                    <Typography
                        variant="h5"
                        css={classes.active}
                    >
                        {isInProcess ? t('PROCESS_RUNNING') : ''}
                    </Typography>
                    <Typography
                        variant="h5"
                        css={classes.bottomText}
                    >
                        {answeredBy ? `${t('BEING_ANSWERED_BY')} ${answeredBy}` : ''}
                    </Typography>
                    <Typography
                        variant="h5"
                        css={classes.bottomText}
                    >
                        {currentOrderNumber ? `${t('USED_IN_ORDER')} ${currentOrderNumber}` : ''}
                    </Typography>
                </div>
            </div>
        </div>
    )
}

AssertDashboardCardItem.propTypes = propTypes

export default AssertDashboardCardItem
